import { BusinessFlow } from '../types/otp.type';

export const OTP_BUSINESS_FLOWS_WITH_RECAPTCHA = [
  BusinessFlow.REMITTANCE_B2B,
  BusinessFlow.EXCHANGE_B2B,
  BusinessFlow.MULTI_TRANSACTION_B2B,
  BusinessFlow.RFQ_REMITTANCE,
  BusinessFlow.SIGN_IN_B2B,
  BusinessFlow.BENEFICIARY_CREATE_B2B,
  BusinessFlow.BENEFICIARY_EDIT_B2B,
] as const;
